<template>
  <div class="main-banner">
    <div class="content">
      <h1 class="main-title" v-html="mainTitle" />
      <h2 class="sub-title" v-html="subTitle" />
      <a class="evaluation-btn" :href="btn.link" :target="btn.target">{{ btn.text }}</a>
    </div>
    <div class="img-content">
      <img
        class="banner-img"
        v-lazy-load :data-src="isMobile ? touchImage.url : webImage.url"
        :alt="isMobile ? touchImage.webAltInfo : webImage.webAltInfo"
        :data-not-lazy="true"
      >
    </div>
    <div class="semicircle">
      <div class="small-circle" />
    </div>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin],
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-banner {
  width: 100%;
  height: 556px;
  background: #f8e8cc;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;

  .content {
    width: 1252px;
    margin: 0 auto;
    position: relative;
    z-index: 2;

    .main-title {
      max-width: 705px;
      font-size: 50px;
      font-family: 'Roboto-Bold', sans-serif;
      font-weight: bold;
      color: #f45d00;
      line-height: 62px;
    }

    .sub-title {
      margin-top: 29px;
      max-width: 650px;
      font-size: 24px;
      font-family: 'Roboto-Flex', sans-serif;
      font-weight: 500;
      color: #787878;
      line-height: 37px;
      letter-spacing: 0.72px;
    }

    .evaluation-btn {
      margin-top: 42px;
      height: 56px;
      width: 288px;
      background: #f45d00;
      border-radius: 50px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-family: 'Roboto-Flex', sans-serif;
      font-weight: bold;
      color: #fff;
      transition: all 0.3s linear;

      &:hover {
        border: 3px solid #fa6000;
        background: #fff;
        color: #fa6000;
      }
    }
  }

  .img-content {
    position: absolute;
    width: 1252px;
    height: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    .banner-img {
      position: absolute;
      bottom: 0;
      right: -111px;
      width: 756px;
      height: 504px;
    }
  }

  .semicircle {
    position: absolute;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background-color: #fbe2ba;
    left: -140px;
    top: 144px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 0;

    .small-circle {
      width: 172px;
      height: 172px;
      border-radius: 50%;
      background: #f8e8cc;
    }
  }
}

/* 宽屏桌面（1440px-1919px） */
@media (min-width: 1440px) and (max-width: 1919px) {
  .main-banner {
    .content {
      width: 1250px;
    }

    .img-content {
      position: absolute;
      width: 1250px;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      .banner-img {
        position: absolute;
        bottom: 0;
        right: -95px;
        width: 756px;
        height: 504px;
      }
    }
  }
}

/* 标准桌面（1280px-1439px） */
@media (min-width: 1280px) and (max-width: 1439px) {
  .main-banner {
    .content {
      width: 100%;
      padding-left: 66px;

      .main-title {
        font-size: 48px;
        line-height: 60px;
      }
    }

    .img-content {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      .banner-img {
        position: absolute;
        bottom: 0;
        right: -47px;
        width: 720px;
        height: 480px;
      }
    }
  }
}

@media (min-width: 769px) and (max-width: 1279px) {
  .main-banner {
    height: 486px;

    .content {
      width: 100%;
      padding-left: 43px;

      .main-title {
        font-size: 48px;
        line-height: 60px;
      }
    }

    .img-content {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      .banner-img {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 560px;
        height: 373px;
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .main-banner {
    width: auto;
    height: auto;
    background: #f8e8cc;
    flex-direction: column;

    .content {
      width: 100%;
      margin: 0 auto;
      position: relative;
      display: flex;
      flex-direction: column;

      .main-title {
        margin: 8.8vw auto 0;
        width: 78.933vw;
        text-align: center;
        font-size: 8.533vw;
        line-height: 10.4vw;
      }

      .sub-title {
        margin: 3.467vw auto 0;
        width: 78.933vw;
        text-align: center;
        font-size: 4.267vw;
        line-height: 6.933vw;
        letter-spacing: 0.128vw;
      }

      .evaluation-btn {
        margin: 5.6vw auto 0;
        width: 42.933vw;
        height: 10.667vw;
        border-radius: 1.6vw;
        font-size: 3.733vw;
      }
    }

    .img-content {
      margin-top: 5.067vw;
      position: relative;
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 0;
      top: 0;
      transform: none;

      .banner-img {
        position: relative;
        width: 100vw;
        height: 76.8vw;
        right: 0;
      }
    }

    .semicircle {
      display: none;
    }
  }
}
</style>
